import { z } from 'zod'

type NoDefault<T> = T extends z.ZodDefault<infer I> ? I : T
type PatchShape<S extends z.ZodRawShape> = { [K in keyof S]: z.ZodOptional<NoDefault<S[K]>> }

/**
 * PATCH body from a create schema: every field optional, defaults removed. zod 4 applies `.default()`
 * inside `.partial()` as well, so `Create….partial()` would fill a missing field with its default and the
 * update would silently reset it (e.g. a commitment's containerId to null, a container's aiPolicy).
 */
export function patchOf<S extends z.ZodRawShape>(schema: z.ZodObject<S>): z.ZodObject<PatchShape<S>> {
  const shape: Record<string, z.ZodType> = {}
  for (const [key, field] of Object.entries(schema.shape)) {
    const inner = field instanceof z.ZodDefault ? (field.unwrap() as z.ZodType) : (field as z.ZodType)
    shape[key] = inner.optional()
  }
  return z.object(shape) as unknown as z.ZodObject<PatchShape<S>>
}
